import SharedIntegrated from '../shared-integrated';
import {loadUserTracker} from "../../core/user-tracker/index.js";

SharedIntegrated.setGlobal(window);

//@ 필요시 체크
// const {isNewSignup, _ENTER_YN, recommendId, email, userNm, companyName} = window;

$(document).ready(async function () {
    if(!Often.isGlobal()) { // 플로우는 한국어로 설정
        setKoreanLanguage();
    }
    await Internationalization.asyncInitSetting();
    const Integrated = await import('./integrated.js');
    Integrated.setGlobal();
    loadUserTracker();
    const planId = getSelectedPlan();

    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("callback") === "extension") {
        window.completeLoginCallback = () => {
            window.opener.postMessage({ action: "refreshWritingView" }, "*");
            window.close();
            return true;
        };
        SignUpViewChanger.loadBusinessEmailView(planId);
        return;
    }

    Mutil.mlog(planId);
    Mutil.mlog(!!window?.isWebViewAccess ? "WEB_VIEW" : "웹 브라우저");
    SignUpViewChanger.addBackEvent(); // 뒤로가기 이벤트

    if(isJoinWaitAccount()) {
        SignUpViewChanger.loadCompanyJoinWaitView(getUserId());
        return;
    }

    if(isAuthNumPage()) {
        SignUpViewChanger.loadFirstEmailAuthView(planId, getAuthEmail());
        return
    }

    if(Often.isGlobal && window.location.pathname === '/paidSignup.act') {
        SignUpViewChanger.loadMorningmateAppSumoView();
        return;
    }

    if(Often.isGlobal() && !hasInviteKey()) {
        const snsData = Mutil.getLocalJson("SNS_ACCOUNT_SETTING");
        isAfterSnsLogin()  && !Mutil.empty(snsData) ? await SignUpViewChanger.loadProfileView(planId, snsData) : SignUpViewChanger.loadBusinessSnsView(planId);
        return;
    }

    if(isGuestSignUp(planId)) {
        SignUpViewChanger.loadGuestEmailView();
        return;
    }

    if (hasInviteKey()) {
        SignUpViewChanger.loadProjectInvitationView()
        return
    }

    SignUpViewChanger.loadBusinessEmailView(planId)
});

$(window).on('load', function () {
    setTimeout(function () {
        MonitorUtil.loadGtm();
    }, 1000);
})

function setKoreanLanguage() {
    Often.setCookie('FLOW_LANG', 'ko', 30 * 12 * 10);
}
function isAuthNumPage() {
    return !!window?.isDirectLoadAuthNumView && Mutil.exist(getAuthEmail());
}
function isGuestSignUp(planId) {
    return planId === "guest";
}

// @Todo 플랜 적용시 체크
function getSelectedPlan() {
    if(location.search.indexOf("guest") >= 0) {
        return "guest";
    }
    const planQS = location.search.split('&').find(x => /plan=/i.test(x));
    return  planQS?.replace(/plan=/i, "") ?? CommonJoin.getDefaultPlanId();
}

function isAfterSnsLogin() {
    return !!window?.isDirectLoadUserProfileView
}

function getAuthEmail() {
    return Mutil.n2v(window?.authEmail);
}
function isJoinWaitAccount() {
    return Mutil.isAct("joinwait");
}
function getUserId() {
    const userIdQS = location.search.split('&').find(x => /userId=/i.test(x));
    return userIdQS?.replace(/userId=/i, "").replace("?" ,"") ?? Mutil.n2v(Mutil.getCookie("joinUserId"));
}

function hasInviteKey() {
    return !Mutil.empty(window?.CONNECT_INVITE_KEY)
}
